import CustomButton from "components/Atoms/CustomButton"
import React, { useMemo } from "react"
import useRouteStore from "../../routes.store"

const RouteAssignmentFooter = ({ disabled = false }) => {
  const store = useRouteStore()

  const data = store.data
  const step = data.step
  const nextStep = store.nextStep
  const props = useMemo(() => {
    switch (step) {
      case "select":
        return {
          text: "Create sequence for the outlets",
          onClick: () => {
            nextStep()
          },
        }

      case "order":
        return null

      default:
        return null
    }
  }, [step, nextStep, data])
  return (
    <footer className="bg-white p-2 flex justify-end shrink-0">
      {step === "order" && (
        <CustomButton
          disabled={disabled}
          icon="map-marker"
          className="mr-2"
          text="Preview Route"
          onClick={store.generatePreviewRoute}
        />
      )}
      {props && (
        <CustomButton disabled={disabled} intent="success" {...props} />
      )}
    </footer>
  )
}

export default RouteAssignmentFooter
